// The compact footer keeps the original forms and policy links in a native
// disclosure. Expose them when selecting their blocks in the Theme Editor.
document.addEventListener('shopify:block:select', (event) => {
  const footer = event.target.closest('.mm-footer-more');
  if (footer) footer.open = true;
});
document.addEventListener('shopify:section:select', (event) => {
  const footer = event.target.querySelector('.mm-footer-more');
  if (footer) footer.open = true;
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const footer = event.target.closest('.mm-footer-more[open]');
  if (!footer) return;
  footer.open = false;
  footer.querySelector('summary').focus();
});

// Same-page navigation must release Dawn's drawer focus trap and scroll lock.
document.addEventListener('click', (event) => {
  const link = event.target.closest('#MiniMatchHeader #menu-drawer a[href^="#"]');
  if (!link) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!target) return;
  const drawer = link.closest('header-drawer');
  const toggle = drawer.querySelector('#Details-menu-drawer-container > summary');
  drawer.closeMenuDrawer(event, toggle);
  toggle.setAttribute('aria-expanded', 'false');
});


// Keep accordion submenus independent of Dawn's sliding-panel handlers.
(() => {
  const selector = '#MiniMatchHeader .mm-menu-disclosure';
  const close = (details) => {
    details.open = false;
    details.querySelectorAll('details[open]').forEach(child => { child.open = false; });
  };
  const init = () => {
    document.querySelectorAll(selector).forEach(details => {
      if (details.dataset.mmReady) return;
      details.dataset.mmReady = 'true';
      const summary = details.querySelector(':scope > summary');
      const sync = () => summary.setAttribute('aria-expanded', String(details.open));
      sync();
      details.addEventListener('toggle', sync);
      if (!details.closest('.mm-header-nav')) return;
      details.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
        details.parentElement.parentElement.querySelectorAll(':scope > li > details').forEach(sibling => {
          if (sibling !== details && !sibling.contains(document.activeElement)) close(sibling);
        });
        details.open = true;
      });
      details.addEventListener('pointerleave', () => {
        if (!details.contains(document.activeElement)) close(details);
      });
      details.addEventListener('focusout', () => setTimeout(() => {
        if (!details.contains(document.activeElement) && !details.matches(':hover')) close(details);
      }));
    });
  };
  document.addEventListener('click', event => {
    const summary = event.target.closest(`${selector} > summary`);
    if (!summary) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const details = summary.parentElement;
    if (details.open) close(details); else details.open = true;
    summary.setAttribute('aria-expanded', String(details.open));
  }, true);
  document.addEventListener('keyup', event => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest(`${selector}[open]`);
    if (!details) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    close(details);
    details.querySelector(':scope > summary').focus();
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll('.mm-header-nav .mm-menu-disclosure[open]').forEach(details => {
      if (!details.contains(event.target)) close(details);
    });
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
